import { h } from "preact";

export default function MiniCartEmpty({
  emptyMessage,
  emptyCtaCopy,
  emptyCtaUrl,
}) {
  return (
    <div className="mini-cart-empty">
      <p className="sh2">{emptyMessage}</p>
      <a
        href={emptyCtaUrl}
        className="mini-cart__empty-button button button--black"
      >
        {emptyCtaCopy}
      </a>
    </div>
  );
}
